module.exports = __webpack_public_path__ + "static/Homestay-1e124210e1707f3353ab4cc903be9fe3.mp4";